
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVerticalPluggedNoCharge75 as ObiBatteryVerticalPluggedNoCharge75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-plugged-no-charge-75.js';
 
 
 

 
 export const ObiBatteryVerticalPluggedNoCharge75 = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-plugged-no-charge-75',
   elementClass: ObiBatteryVerticalPluggedNoCharge75Element,
   events: {
     
   }
  });
 
 